module.exports = __webpack_public_path__ + "9af168911ba9ed84a642e9a7132bcdc0.png";


//////////////////
// WEBPACK FOOTER
// ./components/bare_home/keller.png
// module id = 593
// module chunks = 0